import * as type from './constant';

export const getActivity = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getActivitySuccess = (payload, month) => ({
  type: type.GET_SUCCESS,
  payload,
  month,
});

export const getActivityError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addActivity = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addActivitySuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateActivity = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateActivitySuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteActivity = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteActivitySuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationActivityError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
